import './utils/rem'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import './styles/index.scss'
import PageHeader from '@/components/PageHeader.vue'
import BaseTable from '@/components/BaseTable.vue'
import OperationActions from '@/components/OperationActions.vue'
import { operationColumnWidth } from '@/utils/tableActions'
import { getToken } from '@/utils/request'
import { getFirstAuthorizedPath, hasRoutePermission, saveLastAuthorizedRoute, saveRouterList } from '@/utils/permission'
import { getMyRoutes } from '@/api/auth'
// px2rem.js 内部会把 this.px2rem() 挂到 Vue.prototype 上，这里只需要 import 触发其副作用，
// 必须在 main.js 全局引入一次——不能只依赖个别页面 import px2remMixin，
// 否则路由懒加载时，如果用户第一个进入的页面恰好没有 import 这个模块（比如只用 px2rem() 不用 tableKey 的页面），
// Vue.prototype.px2rem 还没注册就会报 "px2rem is not a function"
import '@/utils/px2rem'

/* ── 路由守卫：登录态 + 菜单权限 ─────────────────────── */
const WHITE_LIST = ['/login', '/401', '/403', '/404', '/500']

// 每次刷新页面只拉一次最新路由（内存标志，刷新后自动重置）
let routesFetched = false

const getVisibleMenuRoutes = () => {
  const layoutRoute = router.options.routes.find(r => r.path === '/' && r.children && r.children.length)
  const children = (layoutRoute && layoutRoute.children) || []
  return children
    .filter(r => r.meta && !r.meta.hidden && r.meta.title && r.meta.menu)
    .map(r => ({ path: '/' + r.path, meta: r.meta }))
}

router.beforeEach((to, from, next) => {
  if (WHITE_LIST.includes(to.path)) {
    next()
    return
  }

  if (!getToken()) {
    next(`/login?redirect=${to.fullPath}`)
    return
  }

  // 每次刷新/打开页面，第一次导航时拉最新路由（角色菜单变更后刷新页面即生效）
  if (!routesFetched) {
    routesFetched = true
    getMyRoutes().then(res => {
      const routeList = res.data || []
      saveRouterList(routeList)
      store.commit('SET_USER', { routerList: routeList })
    }).catch(() => {}).finally(() => {
      // 路由拉取完成后继续原来的导航逻辑
      continueNavigation(to, next)
    })
    return
  }

  continueNavigation(to, next)
})

function continueNavigation(to, next) {
  if (to.path === '/') {
    const firstAuthorizedPath = getFirstAuthorizedPath(getVisibleMenuRoutes())
    saveLastAuthorizedRoute(firstAuthorizedPath)
    next(firstAuthorizedPath)
    return
  }

  if (hasRoutePermission(to)) {
    saveLastAuthorizedRoute(to.fullPath)
    next()
    return
  }

  next('/403')
}

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' })
Vue.component('PageHeader', PageHeader)
Vue.component('BaseTable', BaseTable)
Vue.component('OperationActions', OperationActions)
Vue.prototype.$operationColumnWidth = operationColumnWidth

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
